<template>
    <div class="content">
        <h3 class="mt-2 mb-5 ml-2 is-hidden-desktop"><i class="fal fa-question-square fa-fw mr-3"></i>Staff Information</h3>

        <!-- Free-text trip-level staff notes -->
        <div class="white-container content ql-editor" v-if="trip.app_staff" v-html="trip.app_staff"></div>

        <!-- Auto-compiled from the roster: anyone whose birthday lands during the trip -->
        <div class="mt-5" v-if="loading">
            <h5 class="has-text-grey"><i class="fal fa-tennis-ball fa-spin mr-3"></i>Checking the roster for birthdays...</h5>
        </div>
        <div class="mt-5" v-else-if="birthdays.length">
            <h5 class="ml-2 mb-4"><i class="far fa-cake-candles fa-fw mr-2"></i>Birthdays During the Trip</h5>
            <div class="white-container">
                <div class="birthday-item" v-for="b in birthdays" :key="b.id">
                    <div class="birthday-name">
                        {{ b.first_name }} {{ b.last_name }}
                        <span class="birthday-role" v-if="b.role"> &middot; {{ b.role }}</span>
                    </div>
                    <div class="birthday-date"><i class="far fa-calendar-day fa-fw mr-2"></i>{{ b.date | moment('dddd, MMMM Do') }}</div>
                </div>
            </div>
        </div>

        <!-- Nothing at all yet -->
        <div class="white-container content has-text-centered" v-if="!trip.app_staff && !loading && !birthdays.length">
            <h4 class="pt-6 pb-6 has-text-grey"><i class="fal fa-message-captions mr-2"></i> More information will be available later.  Check back soon!</h4>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {client as http} from "../../http_client";

    export default {
        data: function() {
            return {
                loading: false,
                birthdays: []
            };
        },
        computed: {
            ...mapGetters(['trip', 'registration']),
            isStaff: function() {
                return this.registration.type === 'staff' || this.registration.second_type === 'staff';
            }
        },
        methods: {
            loadBirthdays: function() {
                if (!this.registration.id || !this.isStaff) return;
                this.loading = true;
                http.get('/app/trips/' + this.registration.trip_id + '/staff/birthdays').then(response => {
                    this.birthdays = response.data || [];
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
        watch: {
            registration: function() {
                this.loadBirthdays();
            }
        },
        mounted() {
            this.loadBirthdays();
        }
    };
</script>

<style lang="scss" scoped>
    .birthday-item {
        border-left: 3px solid #628b21;
        padding-left: 0.7rem;
        padding-bottom: 0.9rem;
        margin-bottom: 0.9rem;
        border-bottom: 1px solid #ededed;

        &:last-child {
            padding-bottom: 0;
            margin-bottom: 0;
            border-bottom: 0;
        }

        .birthday-name {
            font-weight: 700;
            margin-bottom: 0.3rem;
        }

        .birthday-role {
            font-weight: 400;
            color: #6b6b6b;
            font-size: 0.85rem;
            text-transform: capitalize;
        }

        .birthday-date {
            font-size: 0.95rem;
        }
    }
</style>
